// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"079b4142","156":"220265e9","272":"1ac23d13","580":"838411f5","620":"fcbccb8e","708":"0d4e11b8","748":"111839cc","796":"4728d8f8"}[chunkId] + ".chunk.js";
};